module.exports = __webpack_public_path__ + "static/media/Acheive14.fe903d79.jpg";